import React from 'react';
import { styled, Typography } from '@mui/material';
import { LibraryCard } from 'components/LibraryCard/LibraryCard';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { TransformedLibraryArticle } from 'features/resources/types';
import { ResourceCardGrid, ResourceCardGridCell } from './ResourceCardGrid';

const Container = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}));

interface ResourceDesktopFavouritesProps {
  favoritedArticles: TransformedLibraryArticle[];
  allArticlesLabel: string;
  handleArticleClick?: (article: TransformedLibraryArticle) => void;
  onToggleFavorite: (article: TransformedLibraryArticle) => void;
}

// Desktop-only "Favorites" preview row + "All Articles" label above the full article list (WFMOB-16440).
export const ResourceDesktopFavourites = ({
  favoritedArticles,
  allArticlesLabel,
  handleArticleClick,
  onToggleFavorite,
}: ResourceDesktopFavouritesProps) => {
  const { translation } = useTranslationContext();

  return (
    <>
      <Typography color="grey.800" variant="title3">
        {translation('favorites_header')}
      </Typography>
      <ResourceCardGrid>
        {favoritedArticles.map((article) => (
          <ResourceCardGridCell key={`favorite-${article.id}`}>
            <LibraryCard
              title={article.title}
              imageUrl={article.imageUrl}
              onClick={() => handleArticleClick?.(article)}
              ariaLabel={`${article.title} article`}
              showFavorite
              isFavorited
              onToggleFavorite={() => onToggleFavorite(article)}
            />
          </ResourceCardGridCell>
        ))}
      </ResourceCardGrid>
      <Container>
        <Typography color="grey.800" variant="title3">
          {allArticlesLabel}
        </Typography>
      </Container>
    </>
  );
};
